<template>
<v-container fill-height justify-center align-center >
  <!-- <v-layout row > -->
    <v-flex xs12 sm5 md4 lg3>
      <v-card class="mt-0 pt-0">
          <v-card-title class="blue darken-1">
            <h4 style="color:white">MSBA Document CRM</h4>
          </v-card-title>
        <v-card-text>
           <pre class="text-xs-center subheader">
      {{JSON.stringify(this.$feathers.get('userData'), null, 2)}}
    </pre>
        </v-card-text>
      </v-card>
    </v-flex>
  <!-- </v-layout> -->
  </v-container>
</template>
<script>

export default {
  data() {
    return {
      email: 'test',
      pass: 'test',
      error: false,
      text: '',
      tryingLogin: false
    }
  },
  methods: {
  },
  created() {
    var user = this.$feathers.get('userData')

    this.$userData = user

    if (user == undefined || !user.permissions.includes('administrator')) {
      this.$router.push('search')
    }
    else if (user.permissions.includes('administrator')) {
      this.$router.push('dashboard')
    }
  },
  mounted () {

  }
}
</script>
<style lang="stylus">
  @import '../stylus/main'
</style>
